export const MODULE_TREE = [
  { id: 'RFCDetails', label: 'Details', parent: '' },
  { id: 'Comments', label: 'Comments', parent: '' },
  { id: 'Summary', label: 'Summary', parent: '' },
  { id: 'RFCLines', label: 'RFC Lines', parent: '' },
  { id: 'Notepad', label: 'Notepad', parent: '' },
  { id: 'SalesDiary', label: 'Sales Diary', parent: '' },
  { id: 'DiaryDetails', label: 'Diary Details', parent: 'SalesDiary' }
];
